import { ChangeEvent, FocusEvent, KeyboardEvent, MouseEvent } from 'react';

import { TextareaTypes } from '@/common/Textarea/types';

export type HandlerWithValue<V, E> = (value?: V, event?: E) => void;

export const withValue = function <
  T extends
    | ChangeEvent<HTMLTextAreaElement>
    | FocusEvent<HTMLTextAreaElement>
    | KeyboardEvent<HTMLTextAreaElement>
    | MouseEvent<HTMLTextAreaElement>,
>(handler: (value: TextareaTypes.ValueProp, event: T) => void, value: TextareaTypes.ValueProp): (event: T) => void {
  return (event: T): void => {
    if (event?.target?.['value'] !== undefined) value = event.target['value'];
    handler?.(value, event);
  };
};
